import React from 'react';
import { Link } from 'react-router-dom';
import { Box } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { ProviderMedicalRole } from '@uplift/types';
import { EditableSectionRow, EditableSectionRowItem } from '../../../EditableSection';
import { MatchState, UpliftLicenseType } from '@uplift/api';
import { ArchiveMatchButton } from './ArchiveMatchButton.component';
import { getProviderLabelByMedicalRoleAndPrescriberTypes } from './helpers';


const useStyles = makeStyles()(theme => ({
  providerName: {
    textDecoration: 'underline',
    color: theme.palette.text.primary
  },
  archiveButton: {
    minWidth: '130px',
  },
  archivedButton: {
    minWidth: '130px',
    textTransform: 'none',
    textAlign: 'center',
    fontStyle: 'italic',
  }
}));


export type CareTeamMemberSectionItemProps = {
  rowKey: string;
  label: string;
  children?: React.ReactNode | undefined;

  matchId: string;
  state: MatchState;
  providerId?: string;
  patientId?: string;
  archived: boolean;
  sessionsCount: number;
  providerMedicalRole?: ProviderMedicalRole;
  providerPrescriberTypes?: UpliftLicenseType[];
  fullName?: string;
};


export const CareTeamMemberSectionItem: React.FC<CareTeamMemberSectionItemProps> = ({
  matchId,
  providerId,
  patientId,
  providerMedicalRole,
  providerPrescriberTypes,
  archived,
  fullName,
  sessionsCount
}) => {
  const { classes } = useStyles();
  const providerLabel = React.useMemo(() => {
    if (providerMedicalRole && providerPrescriberTypes) {
      return getProviderLabelByMedicalRoleAndPrescriberTypes(providerMedicalRole, providerPrescriberTypes);
    }
    return '';
  }, [ providerMedicalRole, providerPrescriberTypes ]);

  return (
    <EditableSectionRow
      label={providerLabel}
      rowKey={matchId}
      actions={(
        <ArchiveMatchButton
          patientId={patientId}
          matchId={matchId}
          archived={archived}
          providerFullName={fullName}
        />
      )}
      kind="custom"
    >
      <Box display="flex">
        <EditableSectionRowItem title="Name">
          <Link
            className={providerId ? classes.providerName : undefined}
            to={providerId ? `/profile/${providerId}` : ''}
          >
            {fullName}
          </Link>
        </EditableSectionRowItem>
        <EditableSectionRowItem title="Sessions">
          {sessionsCount === -1 ? '–' : sessionsCount}
        </EditableSectionRowItem>
      </Box>
    </EditableSectionRow>
  );
};
